import BackendConnector from './backendConnector';

export default class CampaignHttpService {
    static getCampaign(id) {
        return BackendConnector.get(`campaign/${id}`);
    }

    static startCampaign(positionId) {
        return BackendConnector.put(`position/${positionId}/campaign/status/start`);
    }

    static restartAutoContactCampaign(positionId) {
        return BackendConnector.put(`position/${positionId}/campaign/status/restart`);
    }

    static pauseCampaign(positionId) {
        return BackendConnector.put(`position/${positionId}/campaign/status/pause`);
    }

    static resumeCampaign(positionId) {
        return BackendConnector.put(`position/${positionId}/campaign/status/resume`);
    }

    static setCampaignToNonStarted(positionId) {
        return BackendConnector.put(`position/${positionId}/campaign/status/nonStarted`);
    }

    static getCampaignStatus(positionId) {
        return BackendConnector.get(`position/${positionId}/campaign/status`);
    }

    static canAddCandidatesToCampaign(positionId, employerWorkflowStatus) {
        return BackendConnector.post(`position/${positionId}/campaign/candidates/add/available`, { employerWorkflowStatus });
    }

    static addCandidatesToCampaign(positionId, talentIds) {
        return BackendConnector.post(`position/${positionId}/campaign/candidates/add`, { talentIds });
    }

    static getCampaignsForImport(employerId) {
        return BackendConnector.get(`/employer/${employerId}/campaigns`);
    }

    static getCampaignByPositionId(positionId) {
        return BackendConnector.get(`position/${positionId}/campaign`);
    }

    static updateJobCampaign(positionId, details) {
        return BackendConnector.post(`position/${positionId}/campaign`, details);
    }

    static updateCampaign(campaignId, details) {
        return BackendConnector.put(`campaign/${campaignId}`, details);
    }

    static updateCampaignSender(positionId, details) {
        return BackendConnector.post(`position/${positionId}/campaign/sender`, details);
    }

    static getCampaignEmails(positionId) {
        return BackendConnector.get(`position/${positionId}/campaign/email`);
    }

    static addCampaignEmail(positionId, emailData) {
        return BackendConnector.put(`position/${positionId}/campaign/email`, emailData);
    }

    static updateCampaignEmail(positionId, emailData) {
        return BackendConnector.post(`position/${positionId}/campaign/email`, emailData);
    }

    static copyCampaignMessages(positionId, sourcePositionId) {
        return BackendConnector.post(`position/${positionId}/campaign/messages/copy`, { sourcePositionId });
    }

    static getUserDefaultCampaign() {
        return BackendConnector.get('position/campaign/default');
    }

    static sendTestMessage({
        campaignId,
        message,
        positionId,
        employerId,
        skipUrl,
    }) {
        return BackendConnector.post(`campaign/${campaignId}/sendTestMessage`, {
            positionId, message, employerId, skipUrl,
        });
    }

    static getSystemMessages() {
        return BackendConnector.get('campaign/messages/system');
    }

    static getUserMessages({ userId, role }) {
        return BackendConnector.post(`campaign/messages/user/${userId}`, { role });
    }

    static search(filter) {
        return BackendConnector.post('campaign/search', { filter });
    }

    static getEmployerCampaignTableData(employerId) {
        return BackendConnector.get(`/employer/${employerId}/employerCampaignsTableData`);
    }

    static getDefaultCampaign(employerId) { // system or employer type
        return BackendConnector.get(`/employer/${employerId}/campaign/default`);
    }

    static getEmployerDraftCampaign(employerId) {
        return BackendConnector.get(`/employer/${employerId}/campaign/draft`);
    }

    static createEmployerCampaign(employerId, campaignData) {
        return BackendConnector.post(`/employer/${employerId}/campaign/create`, campaignData);
    }

    static cloneCampaign(campaignId, { employerId }) {
        return BackendConnector.post(`/campaign/${campaignId}/clone`, { employerId });
    }

    static deleteCampaign(campaignId) {
        return BackendConnector.delete(`/campaign/${campaignId}/delete`);
    }

    static getEmployerCampaign({ employerId, campaignId }) {
        return BackendConnector.get(`employer/${employerId}/employerCampaign/${campaignId}`);
    }

    static getJobCampaignDefaultSenderByRole({ campaignId, role }) {
        return BackendConnector.get(`campaign/${campaignId}/defaultSender/byRole/${role}`);
    }

    static unSetDefaultEmployerCampaigns(employerId) {
        return BackendConnector.get(`employer/${employerId}/unSetDefaultCampaigns`);
    }

    static getTestContextData({ employerId, campaignId }) {
        return BackendConnector.get(`employer/${employerId}/campaign/${campaignId}/getTestContextData`);
    }

    static applySystemCampaignUpdates(campaignId, data) {
        return BackendConnector.post(`system/campaign/${campaignId}/applyUpdates`, data);
    }
}
